module.exports = "/assets/data/d0f76fd4bfb227f59aaa15b3a4560ff5-DG13.data.json";